import React, {useState} from "react";
import { Portlet, PortletHeader } from "../../../../components/Portlet";
import AirportForm from "../components/airportForm";
import { connect } from "react-redux";
import { CreateItem } from "../../../../redux/actions/base";
import { AirportListRoute } from "../../../routesConstants";
import {Helmet} from "react-helmet";
import {useNavigate} from "react-router";
import axios from "../../../../helpers/axios";
import BlockUi from "@availity/block-ui";

const tempData = {
  name:'',
  nameEn:'',
  iatacode:'',
  icaoCode:'',
  stateCode:'',
  country:'',
  lat:'',
  lon:''
}
const AirportCreatePage = ({ CreateItem }) => {
  const [loading, setLoading] = useState()
  const navigation = useNavigate()
  const callback = (values, cb) => {
    setLoading(true)
    axios.put("/api/locations/airports", values)
      .then(()=>navigation(AirportListRoute))
      .finally(()=>setLoading(false))

  };
  return (
    <>
      <Helmet>
        <title>Аэропорт</title>
      </Helmet>
      <BlockUi blocking={loading}>
        <AirportForm onSubmit={callback}
                     data={tempData}/>
      </BlockUi>
    </>
  );
};

export default connect(null, { CreateItem })(AirportCreatePage);
